import './src/scss/main.scss'
import PropTypes from 'prop-types'

export const wrapRootElement = ({ element }) => element
wrapRootElement.propTypes = {
    element: PropTypes.any
}
